const redeemedCollectibleStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] overflow-hidden bg-white max-w-[400px] text-black min-w-[300px]
                screen-500:min-w-[350px]
    `,
    closeButton: `absolute top-2 right-2 text-white rounded-full cursor-pointer`,
    imageContainer: `relative w-full h-full`,
    image: `w-full max-h-[500px] object-cover`,
    textOverlay: `flex items-center absolute bottom-0 left-0 w-full bg-[rgba(255,255,255,0.75)] py-2 px-3`,
    message: `text-[17px] leading-[25px] font-Suisse text-primaryHeading`,
  };
  
  export { redeemedCollectibleStyles };